import { NewUpdateComponent } from './../../dialogs/new-update/new-update.component';
import { MatDialog } from '@angular/material/dialog';
import { Config } from './../../other/interfaces';
import { Component, HostListener, OnInit } from '@angular/core';
import { DataService } from '@services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { ApiService } from '@services/api.service';
import { HttpClient } from '@angular/common/http';
import { HeaderLink } from '@other/interfaces';
import { CognosService } from '@services/cognos.service';
import { BehaviorSubject, interval, timer } from 'rxjs';
import { tap, startWith } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { versionToNumber } from '@other/functions';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ConfigActions, ConfigState } from '@store/config.state';
import { LogService } from '@services/log.service';
import { ConfigService } from '@services/config.service';

@Component({
    selector: 'dip-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  reports = new BehaviorSubject<HeaderLink[]>([]);

  // Log current NGXS State when pressing Shift+X, everywhere
  @HostListener('document:keydown.Shift.X')
  showState() {
    try {
      console.log(this._store.snapshot());
    } catch (error) {
      console.error('Error showing state:', error);
    }
  }
  // set loglvl to *
  @HostListener('document:keydown.Shift.D')
  setloglvl() {
    try {
      localStorage.setItem('co_loglvl', '*');
      localStorage.setItem('co_logtag', '*');
    } catch (error) {
      console.error('Could not set localstorage loglvl. Error:', error);
    }
  }

  @SelectSnapshot(ConfigState) config !: Config;

  constructor(
    public data: DataService,
    private translate: TranslateService,
    private _location: LocationStrategy,
    private router: Router,
    private api: ApiService,
    private http: HttpClient,
    private _cognos: CognosService,
    private _store: Store,
    private _dialog: MatDialog,
    private logger: LogService
  ) {
    this.logger.info("AppComponent","constructor", "!! Starting the AppComponent !!")
    let links = []

    if (this.config.corpintra || location.hostname !== 'localhost') {
      // ------------------------------------------------------------
      // Heartbeat and check updates
      // ------------------------------------------------------------
      const pathname = location.pathname.substring(0, location.pathname.lastIndexOf('/')) + '/';
      this.api.heartbeat = interval(this.config.heartbeat).subscribe(_ => {
        // Request to common config instead of keep.alive.txt
        // Therefore we can maintain session alive and check newer versions at the same time
        try {
          this.http.get<Config>(pathname + `assets/config_common.json`, {}).subscribe(res => {
            this.logger.info("AppComponent","constructor-heartbeat", "config_common.json: "+this.config.version)
            // Parse text to JSON and compare version with current config
            const currentVersion = versionToNumber(this.config.version);
            const newerVersion = versionToNumber(res.version);
            if (newerVersion > currentVersion) {
              // New version detected
              this._dialog.open(NewUpdateComponent, {
                disableClose: true,
                panelClass: 'newUpdate'
              });
            }
          });
        } catch (error) {
          this.logger.error("AppComponent","constructor-heartbeat", "Error getting config_common.json: "+error)
        }

      });
      // If going to a report, check it has access, and if not, redirect to another one with access
      let retryInterval = 1000; // Retry every 1000ms (1 second)
      let cookieName = 'userCapabilities'; // The name of the cookie to check for
      let max_retries = 100;
      let retries = 0;

      // Check for the cookie using while loop with max timeout
      let cookieFound = false;
      const maxTimeout = 10000; // 10 seconds
      let startTime = Date.now();

      // pass local variables to the async function
      // (async () => { // Wrap the logic in an async IIFE
      //   while (!cookieFound && Date.now() - startTime < maxTimeout) {

      //     this.logger.info("AppComponent","constructor", "Checking for cookie: "+cookieName)
      //     try {
      //       // Check for the cookie
      //       const cookieValue = this.getCookieByName(cookieName);
      //       cookieFound = cookieValue !== null;
      //       this.logger.info("AppComponent","constructor", "cookieFound: "+cookieFound)
      //       if (!cookieFound) {
      //         await new Promise(resolve => setTimeout(resolve, 300)); // Wait for 1 second
      //       } else {
      //         let foo = new ConfigService(this.http, this._cognos, this._store, this.logger);
              
      //         foo.load().then(() => {
      //           // this.logger.info("AppComponent","constructor", "foo.load():"+JSON.stringify(this._store.selectSnapshot(ConfigState)))
      //           this.logger.info("AppComponent","constructor", "foo.load():"+JSON.stringify(this._store.snapshot().config))
                
      //           this.logger.info("AppComponent","constructor", "Cookie found: "+cookieValue)  

      //           // If cookie is found, do the necesarry things, like removing iFrame, loading capabilities and so on
      //           const iframe = document.querySelector('#cognos-login-iframe');

      //           // If we have a cookie, remove the iframe
      //           if (iframe) {
      //             this.logger.info("AppComponent","constructor", "removing cognos-login-iframe")
      //             iframe.remove();
      //           } else {
      //             this.logger.info("AppComponent","constructor", "cognos-login-iframe not found. Not removing it.")
      //           }

      //           // finally navigate to the first report with access by omitting the popState event
      //           this.logger.info("AppComponent","constructor", "====================================================")
      //           this.logger.info("AppComponent","constructor", "====================================================")
      //           this.logger.info("AppComponent","constructor", "====================================================")
      //           // if window.location does not end with /order-intake, then navigate to it by using window.location.href
      //           if (!window.location.href.endsWith('/order-intake')) {
      //             this.logger.info("AppComponent","constructor", "At this point we should have navigated to: /order-intake, but could not find the URL. So adding this 'manually' using window.location.")
      //             window.location.href = window.location.href + '/order-intake';
      //           }
      //         });
      //       }
      //     } catch (error) {
      //       this.logger.info("AppComponent","constructor", "Cookie not available yet.")
      //       // sleep 1 second
      //       await new Promise(resolve => setTimeout(resolve, 1000));
      //     }
      //   }
      // })(); // Immediately invoke the async function
    }

    // This is called when the URL changes
    // this.logger.info("AppComponent","constructor", "calling onPopState")
    // this._location.onPopState(() => {
    //   this.logger.info("AppComponent","constructor", "onPopState: this.data.currentLevel: "+this.data.currentLevel)
    //   if (this.data.currentLevel === 1 && this.data.title !== 'order_intake') {
    //     this.logger.info("AppComponent","constructor", "onPopState: redirecting to order-intake")
    //     this.router.navigate(['order-intake'], { replaceUrl: true, queryParamsHandling: 'merge' });
    //   }
    // });

    this.logger.info("AppComponent","constructor", "calling data.init()")
    data.init();

    this.translate.setDefaultLang('en');
    this.translate.use(localStorage.getItem('lang') || this.config.language);
    this.logger.info("AppComponent","constructor", "calling reports.next()")
    this.reports.next(links);
    if (!location.hash.includes('help') && !location.hash.includes('about') && links.length === 0) {
      // Unable to access to any report, then main page is Help
      this.logger.info("AppComponent","constructor", "Unable to access to any report, then main page is Help")
      // this.logger.info("AppComponent","constructor", "reports.length: "+this._store.selectSnapshot(ConfigState).reportLinks.length)
      this.logger.info("AppComponent","constructor", "reports.length: "+this._store.snapshot().config.reportLinks.length)
      // this.logger.info("AppComponent","constructor", "reports: "+JSON.stringify(this._store.selectSnapshot(ConfigState).reportLinks))
      this.logger.info("AppComponent","constructor", "reports: "+JSON.stringify(this._store.snapshot().config.reportLinks))
      // this.reports.next(this._store.selectSnapshot(ConfigState).reportLinks);
      this.reports.next(this._store.snapshot().config.reportLinks); 
      // this.router.navigate(['/help']);
    } else {
      this.logger.info("AppComponent","constructor", "reports.length2: "+this.reports.getValue().length)
      this.logger.info("AppComponent","constructor", "reports2: "+JSON.stringify(this.reports.getValue()))
    }
  }

  // Function to get a cookie by name
  getCookieByName(name: string): string | null {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim(); // Remove leading/trailing spaces
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null; // Return null if cookie not found
  }


  preloadThings() {
    this.logger.info("AppComponent","preloadThings", "preloading things")
    new Image().src = 'assets/update.svg'; // Preload the SVG
  }

  ngOnInit() {
    this.logger.info("AppComponent","ngOnInit", "AppComponent ngOnInit")
    this.data.lightTheme.valueChanges.pipe(
      startWith(localStorage.getItem('light_theme') === 'yes'),
      tap(_ => this.data.sidenavOpened.next(false)),
      tap(value => localStorage.setItem('light_theme', value ? 'yes' : 'no'))
    ).subscribe(light => {
      if (light) {
        document.body.setAttribute('theme', 'light');
      } else {
        document.body.setAttribute('theme', 'new-dark');
      }
      });
      this.preloadThings();
  }

  close() {
    this.data.sidenavOpened.next(!this.data.sidenavOpened.getValue());
  }

}